/**
 * getVideoMetaData
 * @param {string} url
 * @returns {Promise<{height:number,width:number, duration:number}>} duration 秒
 */
export const getVideoMetaData = (url) => {
  return new Promise((resolve, reject) => {
    let video = document.createElement('video')
    video.src = url
    video.muted = true

    video.addEventListener('loadedmetadata', handleLoadedMetaData)
    function handleLoadedMetaData(e) {
      resolve({
        height: video.videoHeight,
        width: video.videoWidth,
        duration: video.duration
      })
      destroy()
    }

    function destroy() {
      video.removeEventListener('loadedmetadata', handleLoadedMetaData)
      video.src = ''
      video = null
    }
  })
}
